const MCP_CONSENT_RETURN_KEY = 'mcpConsentReturn';
const MCP_CONSENT_PATH = '/mcp';

export function getMcpConsentAuthorizationUrl(query = {}) {
  const keys = Object.keys(query);
  const authorizationUrl = query.authorization_url;

  if (
    keys.length !== 1
    || keys[0] !== 'authorization_url'
    || typeof authorizationUrl !== 'string'
    || authorizationUrl.trim().length === 0
  ) {
    return null;
  }

  return authorizationUrl;
}

export function getMcpAuthorizationPath(authorizationUrl, apiUrl, environment) {
  if (typeof authorizationUrl !== 'string' || authorizationUrl.trim().length === 0) {
    return null;
  }

  try {
    const authorization = new URL(authorizationUrl);
    const api = new URL(apiUrl);
    const isLoopback = ['localhost', '127.0.0.1', '::1'].includes(authorization.hostname);
    const isLocalDevelopment = environment === 'development' && isLoopback;

    if (
      authorization.origin !== api.origin
      || authorization.pathname !== '/oauth/authorize'
      || authorization.username
      || authorization.password
      || authorization.hash
      || (authorization.protocol !== 'https:' && !(isLocalDevelopment && authorization.protocol === 'http:'))
    ) {
      return null;
    }

    return `${authorization.pathname}${authorization.search}`;
  } catch {
    return null;
  }
}

export function saveMcpConsentReturn(authorizationUrl, apiUrl, environment) {
  if (!getMcpAuthorizationPath(authorizationUrl, apiUrl, environment)) {
    clearMcpConsentReturn();
    return false;
  }

  sessionStorage.setItem(MCP_CONSENT_RETURN_KEY, JSON.stringify({
    path: MCP_CONSENT_PATH,
    authorization_url: authorizationUrl
  }));

  return true;
}

export function consumeMcpConsentReturn(apiUrl, environment) {
  const saved = sessionStorage.getItem(MCP_CONSENT_RETURN_KEY);
  clearMcpConsentReturn();

  if (!saved) {
    return null;
  }

  try {
    const target = JSON.parse(saved);
    const keys = Object.keys(target);

    if (
      keys.length !== 2
      || target.path !== MCP_CONSENT_PATH
      || !getMcpAuthorizationPath(target.authorization_url, apiUrl, environment)
    ) {
      return null;
    }

    return {
      name: 'McpConsent',
      query: { authorization_url: target.authorization_url }
    };
  } catch {
    return null;
  }
}

export function clearMcpConsentReturn() {
  sessionStorage.removeItem(MCP_CONSENT_RETURN_KEY);
}
